import { LawInterfacesEnum } from 'CorePackage/MainModule/enums/LawInterfacesEnum';
import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';
import { getLawInterface } from 'CorePackage/MainModule/reducers/coreReducer';

import { knmSearchGetFilters } from '../common/knmSearchGetFilters';

export const getKnmSearchKnms = (state: IRootState) => state.knmSearch.knms;
export const getKnmSearchPage = (state: IRootState) => state.knmSearch.page;
export const getKnmSearchPageCount = (state: IRootState) => state.knmSearch.pageCount;
export const getKnmSearchTotalCount = (state: IRootState) => state.knmSearch.totalCount;
export const getKnmSearchFilter = (state: IRootState) => state.knmSearch.filter;
export const getKnmSearchFilterConverted = (state: IRootState) =>
  knmSearchGetFilters(state.knmSearch.filter || {}, getLawInterface(state) === LawInterfacesEnum.FZ_248);
export const getKnmSearchOrder = (state: IRootState) => state.knmSearch.order;
export const getKnmSearchSearchString = (state: IRootState) => state.knmSearch.searchString;
export const getKnmSearchKnmSupervisionTypesErvkOptionsAll = (state: IRootState) =>
  state.knmSearch.knmSupervisionTypesErvkOptionsAll;
export const getKnmSearchKnmSupervisionTypesOptionsAll = (state: IRootState) => [
  ...(state.knmSearch.knmSupervisionTypesErvkOptionsAll || []),
  ...(state.knmSearch.knmSupervisionTypesOptionsAll || []),
];
